import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.0607 0.93934C15.6464 1.52513 15.6464 2.47487 15.0607 3.06066L7.06066 11.0607C6.47487 11.6464 5.52513 11.6464 4.93934 11.0607L0.93934 7.06066C0.353553 6.47487 0.353553 5.52513 0.93934 4.93934C1.52513 4.35355 2.47487 4.35355 3.06066 4.93934L6 7.87868L12.9393 0.93934C13.5251 0.353553 14.4749 0.353553 15.0607 0.93934Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol